<gt-dialog-header message="{{ dataSource.data.length === 0 ? ('csv_contact_import.header_import' | translate) : ('csv_contact_import.header_choose' | translate)}}" (closing)="closeDialog()" icon="group"></gt-dialog-header>
<mat-dialog-content *ngIf="dataSource.data.length === 0">
  <div fxLayout="row" fxLayoutAlign="start center">{{'csv_contact_import.format_info' | translate}}
    <button mat-icon-button tabindex="-1"><mat-icon (click)="showHelp = !showHelp" color="primary">help</mat-icon></button>
  </div>
  <div *ngIf="showHelp" class="helpText">
    {{'csv_contact_import.help' | translate}}
  </div>
</mat-dialog-content>
<mat-dialog-content class="table-container" *ngIf="dataSource.data.length">
  <mat-table #table [dataSource]="dataSource" matSort>

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox id="master-checkbox"
                      (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [disabled]="!readyForImport(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{'csv_contact_import.col_name' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let row" [ngClass]="{'color-gray': !readyForImport(row)}">{{row.name}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="number">
      <mat-header-cell *matHeaderCellDef>{{'csv_contact_import.col_number' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.number | phoneNumberFormatter}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef>{{'csv_contact_import.col_email' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let row"><a class="color-primary" *ngIf="row.email" href="mailto:{{row.email}}">{{row.email}}</a></mat-cell>
    </ng-container>

    <ng-container matColumnDef="company">
      <mat-header-cell *matHeaderCellDef>{{'csv_contact_import.col_company' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.company}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>{{'csv_contact_import.col_status' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let row" [ngSwitch]="getImportStatus(row)">
        <div *ngSwitchCase="IMPORTSTATUS.EXISTING" class="color-gray" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <mat-icon class="color-gray">error</mat-icon>
          <div>{{'csv_contact_import.existing' | translate}}</div>
        </div>
        <div *ngSwitchCase="IMPORTSTATUS.MISSING_NUMBER" class="color-red" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <mat-icon class="color-red">error</mat-icon>
          <div>{{'csv_contact_import.missing_number' | translate}}</div>
        </div>
        <div *ngSwitchCase="IMPORTSTATUS.MISSING_NAME" class="color-red" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <mat-icon class="color-red">error</mat-icon>
          <div>{{'csv_contact_import.missing_name' | translate}}</div>
        </div>
        <div *ngSwitchCase="IMPORTSTATUS.ERROR" class="color-red" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <mat-icon class="color-red">error</mat-icon>
          <div>{{'csv_contact_import.error' | translate}}</div>
        </div>
        <div *ngSwitchCase="IMPORTSTATUS.IMPORTED_OK" class="color-green" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <mat-icon class="color-green">check_circle</mat-icon>
          <div>{{'csv_contact_import.ok' | translate}}</div>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <input type="file"
         tabindex="-1"
         #fileInput
         name="{{'csv_contact_import.input' | translate}}"
         id="txtFileUpload"
         (change)="changeListener($event)"
         accept=".csv"/>
  <button mat-button *ngIf="dataSource.data.length === 0" class="choose-file-btn" (click)="uploadCSV()"  color="primary">{{'csv_contact_import.choose' | translate}}</button>
  <button mat-button *ngIf="dataSource.data.length" class="save-btn" [disabled]="selection.selected.length === 0" color="primary" (click)="saveAll()">{{'csv_contact_import.save' | translate}}</button>
  <button mat-button *ngIf="dataSource.data.length" class="cancel-btn" color="primary" (click)="cancel()">{{'global.cancel' | translate}}</button>
  <button mat-button (click)="closeDialog()">{{'global.close' | translate}}</button>
</mat-dialog-actions>
